import { FC } from "react";
import { IconProps } from "./types";

export const SocialInstagramFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M10.09 12c0 1.052.855 1.91 1.908 1.91 1.054.001 1.91-.855 1.91-1.909a1.91 1.91 0 0 0-3.818 0z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.679 13.906c.007-.312.013-.623.013-.935l.002-.634a59.32 59.32 0 0 0-.025-2.489 5.24 5.24 0 0 0-.07-.751 2.313 2.313 0 0 0-.22-.667c-.275-.519-.706-.835-1.27-.981a3.767 3.767 0 0 0-.787-.11 22.72 22.72 0 0 0-.87-.026c-.706-.006-1.413-.006-2.12-.006-.536 0-1.072.003-1.607.03-.23.012-.462.03-.689.077a2.23 2.23 0 0 0-.677.244 1.887 1.887 0 0 0-.86 1.06c-.095.28-.14.57-.157.866-.013.237-.024.475-.028.712a71.74 71.74 0 0 0-.01 1.277v.55c-.002.72-.003 1.44.031 2.16.011.23.03.46.078.686.047.227.116.446.23.649.283.5.714.804 1.268.942.25.062.503.092.76.103.28.013.562.025.842.027.347.004.693.003 1.04.002h.005a215.21 215.21 0 0 1 .813 0c.635.004 1.27.007 1.905-.028.166-.009.33-.023.495-.043.175-.021.346-.063.513-.12a1.91 1.91 0 0 0 1.21-1.202c.09-.258.136-.526.155-.798.014-.198.024-.397.03-.595zm-7.621-1.904a2.942 2.942 0 1 1 5.885 0 2.942 2.942 0 0 1-5.885 0zm5.999-3.747a.688.688 0 1 0 0 1.375.688.688 0 0 0 0-1.375z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.655-14.81c.024.214.038.428.046.642.013.298.023.597.023.895l.003.912c.004.87.008 1.74-.028 2.61a6.7 6.7 0 0 1-.059.683c-.039.268-.1.53-.2.783-.375.959-1.07 1.562-2.057 1.834a4.362 4.362 0 0 1-.958.143c-.21.01-.42.016-.63.022l-.315.01-.177.005h-2.608l-.007-.001-.016-.002-.197-.005-.6-.016a6.74 6.74 0 0 1-.982-.093 3.344 3.344 0 0 1-.793-.243 2.845 2.845 0 0 1-.865-.597 2.863 2.863 0 0 1-.615-.896 3.9 3.9 0 0 1-.3-1.286c-.018-.247-.03-.496-.035-.744a49.896 49.896 0 0 1-.013-1.181l-.001-.714c-.003-.734-.005-1.468.028-2.202a7.33 7.33 0 0 1 .053-.64c.039-.282.104-.557.205-.823a2.88 2.88 0 0 1 1.52-1.642 3.721 3.721 0 0 1 1.34-.323c.244-.017.49-.028.735-.034.351-.009.702-.014 1.053-.013.26.001.52 0 .78-.001a44.46 44.46 0 0 1 2.263.03c.201.01.401.026.6.047.292.031.575.102.851.203a2.882 2.882 0 0 1 1.533 1.287c.244.416.37.874.423 1.35z"
      fill={fill}
    />
  </svg>
);
